import { cn } from 'utils/styles';
import RichTextHeadline from 'components/shared/RichTextHeadline/RichTextHeadline';
import { RelatedArticleProps } from 'libs/contentful/props';
import { PropsWithClass } from 'types/sharedComponents';
import Link from 'components/shared/Link/Link';
import Media from 'components/shared/Media/Media';

export interface SmallArticleProps extends RelatedArticleProps, PropsWithClass {
  showFirstBorder?: boolean;
}

function SmallArticle({
  category,
  articleTitle,
  articleImage,
  slug,
  className,
  showFirstBorder = false,
}: SmallArticleProps) {
  const categoryTitle = category?.label;
  return (
    <div
      data-testid={'smallArticle'}
      className={cn(
        'before:border-t-1 before:absolute before:border-solid before:w-full before:h-0.5 before:-top-6 relative',
        !showFirstBorder && 'nth-of-type-[1]:before:border-none',
      )}>
      <div className={cn('h-full flex flex-row gap-x-4', className)}>
        {articleImage && (
          <div className="flex relative aspect-square w-[110px] h-[110px] items-start">
            <Media media={articleImage} className="rounded-md object-fill" sizes={'110px'} />
          </div>
        )}
        <div className="flex flex-col gap-2 h-full">
          {categoryTitle && (
            <div className="font-serif font-normal text-eyebrow leading-[1.4] capitalize">{categoryTitle}</div>
          )}
          <div className="font-sans text-body-saans font-medium">
            {/* Uses Rich Text Headline to prevent new lines from rendering additional space as with RichTextCopy */}
            <Link internalPage={{ slug }}>
              <RichTextHeadline headline={articleTitle} />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SmallArticle;
